module.exports = __webpack_public_path__ + "img/跳绳.e5823ef8.png";